// extracted by mini-css-extract-plugin
export default {"page":"ErrorPage_page__8+1rd","card":"ErrorPage_card__ntKAn","title":"ErrorPage_title__4kKB4","message":"ErrorPage_message__WgCev","button":"ErrorPage_button__CHA3T"};